module.exports = __webpack_public_path__ + "static/media/ico_report.13811841.svg";